class SliderLoop {
    constructor(slider, options = {}){
        this.options = Object.assign(
            {},
            {      
                incrementation: 2,
                exclude: "",
                sliderPerMob: 2,
                sliderPerDesk: 2,
                mode: "manuel"
            }, 
            options
        );   
        this.sliderSlideCurrent = 0;
        this.slider = slider;
        this.slides = this.slider.querySelectorAll(".slide"); 
        this.contentSlider = slider.closest(".content-slider");
        this.sliderSlideCount = this.slider.querySelectorAll(".slide").length;
        this.sliderBullets = slider.closest(".content-slider")?.querySelectorAll(".bullets .bullet");
        this.buildSlider();
        console.log("Nouvelle instance SliderLoop sur", slider, "avec options", this.options);
        
        if(this.options.exclude == "mobile"){
            if(this.windowWidth >= 992){  
                if(this.options.mode == "auto"){
                    this.sliderPlay();
                }
            }
        }
        if(this.options.exclude == "desktop"){
            console.log("desktop", slider, this.options.mode, this.windowWidth);
            if(this.windowWidth < 992){    
                if(this.options.mode == "auto"){
                    this.sliderPlay();
                }
            }
        }  
        if(this.options.exclude == ""){
            this.resetSlider();
            if(this.options.mode == "auto"){
                this.sliderPlay();
            }
        }

        if(this.contentSlider.querySelector(".right") != null){
             this.contentSlider.querySelector(".right").addEventListener("click", () => {
                this.sliderSlideCurrent++;
                const totalSlides = this.sliderSlideCount;
                const perView = this.slidePerView;
                const totalPages = Math.ceil(totalSlides / perView);
                if(this.sliderSlideCurrent <= totalPages - 1){
                    this.goToSlide(this.sliderSlideCurrent);
                }else{
                    this.sliderSlideCurrent = totalPages - 1;
                }
            });
        }

        if(this.contentSlider.querySelector(".left") != null){
             this.contentSlider.querySelector(".left").addEventListener("click", () => {
                this.sliderSlideCurrent--; 
                if(this.sliderSlideCurrent >= 0){
                    this.goToSlide(this.sliderSlideCurrent);
                }else{
                    this.sliderSlideCurrent = 0;
                }
            });
        }

        window.addEventListener("resize", () => {
            if(this.options.exclude == "mobile"){
                if(this.windowWidth < 992){
                    this.sliderPause();
                    this.resetSlider();
                }else{
                    if(this.options.mode == "auto"){
                        this.sliderPlay();
                    }
                }
            }
            if(this.options.exclude == "desktop"){
                if(this.windowWidth >= 992){
                    this.sliderPause();
                    this.resetSlider();
                }else{
                    if(this.options.mode == "auto"){
                        this.sliderPlay();
                    }
                }
            }  
            if(this.options.exclude == ""){
                this.resetSlider();
                if(this.options.mode == "auto"){
                    this.sliderPlay();
                }
            }
        });
    }

    buildSlider(){
        for (let i = 0; i < this.slidePerView; i++) {
            this.sliderBullets[i].classList.add("active");
        }

        /*
        const numToClone = this.slidePerView;
        const clones = [];

        console.log(numToClone);

        for (let i = 0; i < numToClone && i < this.slides.length; i++) {
            const clone = this.slides[i].cloneNode(true);
            clone.classList.add("clone");
            clones.push(clone);
        }

        console.log(clones);

        // Ajoute les clones à la fin
        clones.forEach(clone => { 
            this.slider.appendChild(clone);
            console.log(clone);
            const imgs = clone.querySelectorAll("img.lazy");
            imgs.forEach(img => {
                img.src = img.dataset.src;
                img.classList.add("loaded");
                img.removeAttribute("data-src");
            });
        });
        */
    }

    resetSlider(){ 
        this.sliderSlideCurrent = 0;
        this.slider.style.transition = 'all 0s ease';
        this.slider.style.transform = `translateX(0px)`;  
        this.slider.offsetHeight;
        this.slider.style.transition = ""; 
        this.sliderBullets.forEach(bullet => {
            bullet.classList.remove("active");
        });
        let indexC = this.sliderSlideCurrent * this.slidePerView;
        this.sliderBullets[indexC]?.classList.add("active");
        if(this.slidePerView > 1){
            for(let i=1; i<this.slidePerView; i++){
                this.sliderBullets[indexC + i]?.classList.add("active");
            }
        }
        /*
        this.slider.querySelectorAll('.slide.clone').forEach(clone => {
            clone.remove();
        });*/
    }

    sliderPause(){ 
        clearInterval(this.sliderBoucle);
        this.sliderBoucle = null;
    } 

    goToSlide(current){    

        const totalSlides = this.sliderSlideCount;
        const perView = this.slidePerView;
        const totalPages = Math.ceil(totalSlides / perView);

        // Vérifie s'il reste moins de slides que "perView"
        let slidesRestantes = totalSlides - (current * perView);

        let translateX;
        if (slidesRestantes < perView && slidesRestantes > 0) {
            // Cas où il reste moins que perView → on avance juste de ce qu’il reste
            translateX = -( (totalSlides - perView) * (this.contentSliderWidth / perView) );
        } else {
            // Cas normal
            translateX = -(current * this.contentSliderWidth);
        }

        this.slider.style.transition = 'transform 0.3s ease';
        this.slider.style.transform = `translateX(${translateX}px)`;   

        this.contentSlider.querySelectorAll(".bullet.active").forEach(b => {b.classList.remove("active")});
        let indexC = current * perView;
        this.sliderBullets[indexC]?.classList.add("active");
        if(perView > 1){
            for(let i=1; i<perView; i++){
                this.sliderBullets[indexC + i]?.classList.add("active");
            }
        }
    }


    sliderPlay(){ 
        console.log("play");
        if (this.sliderBoucle) {
            clearInterval(this.sliderBoucle);
            this.sliderBoucle = null;
        }
        this.sliderBoucle = setInterval(() => { 
            this.sliderSlideCurrent++;  
            const calT = -(this.sliderSlideCurrent * (this.contentSliderWidth));
            this.slider.style.transition = 'transform 0.3s ease';
            this.slider.style.transform = `translateX(${calT}px)`;  
            if (this.sliderSlideCurrent === this.sliderSlideCount / this.slidePerView) {
                this.contentSlider.querySelectorAll(".bullet.active").forEach(b => {b.classList.remove("active")}); 
                this.sliderSlideCurrent = 0; 
                let indexC = this.sliderSlideCurrent * this.slidePerView;
                this.sliderBullets[indexC].classList.add("active");
                if(this.slidePerView > 1){
                    for(let i=1; i<this.slidePerView; i++){
                        let index = indexC + i;
                        this.sliderBullets[index].classList.add("active");
                    }
                }
                setTimeout(() => { 
                    this.slider.style.transition = 'none'; 
                    this.slider.style.transform = 'translateX(0px)'; 
                    this.slider.offsetHeight;
                    this.slider.style.transition = 'transform 0.3s ease';  
                }, 300); 
            }else{
                this.contentSlider.querySelectorAll(".bullet.active").forEach(b => {b.classList.remove("active")});
                let indexC = this.sliderSlideCurrent * this.slidePerView;
                this.sliderBullets[indexC].classList.add("active");
                if(this.slidePerView > 1){
                    for(let i=1; i<this.slidePerView; i++){
                        let index = this.sliderSlideCurrent * this.slidePerView + i;
                        this.sliderBullets[index].classList.add("active");
                    }
                }
            }
            console.log("sliderAuto");
        }, 3000); 
    }  

    get contentSliderWidth(){
        return this.contentSlider.offsetWidth;
    }

    get windowWidth(){
        return window.innerWidth;
    }

    get slidePerView(){
        if(this.windowWidth < 992){
            return this.options.sliderPerMob;
        }else{
            return this.options.sliderPerDesk;
        }
    }
}
 
window.dispatchEvent(new CustomEvent("slider-loop-ready"));